import { Component, OnInit, ViewChild } from '@angular/core';
import { KmsService } from '../../kms.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { element } from 'protractor';
import { KmsEnum } from '../../serves/kms-enum';
import { InstanceInfoViewComponent } from '../../components/instance-info-view/instance-info-view.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
declare var $, d3;
@Component({
    selector: 'app-knowledge-visual',
    templateUrl: './knowledge-visual.component.html',
    styleUrls: ['./knowledge-visual.component.css']
})
export class KnowledgeVisualComponent implements OnInit {
    // 删除确认组件
    @ViewChild("trim") trim: SwMassageConfirmComponent;

    // 定义图谱节点搜索输入数据
    searchNodeName = '';
    // 上一次搜索的参数
    lastSearchNodeName = '';
    // 当前操作是查询节点还是查询关系路径 1:节点；2：关系路径
    searchType:number = 0;
    // 实体列表
    instanceDatasList:any = [];

    // 搜索关系树数据
    searchRelationName = '';
    // 当前节点的关系树数据
    instanceRelationTree:any = [];
    // 当前节点的关系树数据是否加载中
    isRelationTreeLoading:boolean = false;
    // 当前节点搜索展示的关系树数据
    relationTreeData: any = [];
    // 初始化选中的节点
    initSelectedNodes: any = [];
    // 选择后不参与查询的关系节点
    readonlySelfIds:any = [];
    // 当前选中的关系节点数据
    selectedRelationIds = [];

    // 关系路径列表
    pathList:any = [];
    // 当前页的关系路径数据
    pageDatas:any = [];
    // 选中的关系路径索引
    selectedPathIndex:number = -1;
    // 选中的关系路径所在分页
    selectedPage:number = -1;
    // 关系路径列表分页
    pageBase:any = {
        current: 1,
        pageNum: 6,
        pages: 1,
        total: 5
    }

    // 有效的子概念数据模型数据
    ontologyTreeDatas = [];

    // 图谱分类概念颜色
    mapColors = KmsEnum.mapColors;

    // 图谱是否显示加载中
    isLoading = false;

    // 当前选中的节点
    selectedNode:any = {};
    // 实体详情组件传值
    instanceParams:any = {}

    // 当前选中的关系
    selectedLink:any = {
        relation: {
            uuid: ''
        },
        source: {},
        target: {}
    };
    // 编辑关系组件传值
    relationParams:any = {
        upOrAdd: 'Add',           // 新增/编辑实体
        relationData: {}          // 编辑关系时需传递的参数
    }
    // 关系编辑组件title
    title = '';

    // 图谱拖动状态判断
    draggedStatus = 0;

    // 判断图谱是否是初始化加载(1为初始化，2为点击拖到节点)
    initMapStatus = 1;

    // 初始化D3画布
    d3Canvas = {
        simulation: null,  // 图谱的simulation
        svg: null,  // 画布
        width: null,
        height: null,  // 画布的宽高
        marker: null,  // 图谱marker
        defs: null,  // 箭头和图片初始化
        relMap_g: null,  // 其他元素初始化
        patterns: null,  // 图片元素初始化
        edges: null,  // 线元素组合的初始化
        links: null,  // 线初始化
        rect_g: null,  // 关系容器初始化
        rects: null,  // 关系文字背景框初始化
        texts: null,  // 关系名称初始化
        circles: null,  // 节点圆初始化
        circleText: null,  // 节点圆文字初始化
        config: {  // 图谱的基本配置参数
            label_r: 25,
            active_r: 40,
            r: 30, // 头像的半径 [30 - 45]
            linkColor: '#ddd ', // 链接线默认的颜色
            linkBg: '#f8f8f8',
            strokeWidth: 2, // 头像外围包裹的宽度
        },
        time: setTimeout(() => {}, 1000)  // 图谱点击时间
    }



    constructor(
        private create:SwCreateModalComponentService,
        private kmsService: KmsService,
        private routeInfo: ActivatedRoute,
        private message: SwMassageBoxService,
        private router: Router
    ) { }

    ngOnInit() {
        // 查询概念树数据
        this.getOnlogyTreePageList();
        // 获取路由参数
        this.routeInfo.queryParams.subscribe((data: Params) => {
            if (data.selectData) {
                // 判断当前是否为从别的页面跳转
                const params = JSON.parse(data['selectData']);
                this.searchNodeName = params.name;
            }
            this.initMap();
            // 判断初始化时是否传入节点名称参数，传入，则进行查询操作
            if(this.searchNodeName){
                this.getNodeByName();
            }
        });
    }

    // 请求概念数据模型方法
    getOnlogyTreePageList() {
        this.kmsService.getConceptTreeData({}).subscribe(
            data => {
                if (data.code == 200) {
                    if (!data.data) {
                        this.ontologyTreeDatas = [];
                    }
                    let conceptDatas = data.data;
                    this.ontologyTreeDatas  = conceptDatas;
                    this.ontologyTreeDatas.forEach((item, index) => {
                        if(index <= this.mapColors.length-1){
                            item.color = this.mapColors[index];
                        }else{
                            item.color = this.mapColors[0];
                        }
                    });
                }
            }
        );
    }

    // 图谱检索分类下拉点击事件
    handleTypeChange(event) {

    }

    // 图谱检索框enter事件
    handelNodeSearch(event) {
        if (event.keyCode == '13') {
            this.selectedRelationIds = [];
            this.getNodeByName();
        }else{
            this.getInstanceList();
        }
    }

    // 图谱关系树点击事件
    handleVotedClick(event) {
        // 先剔除已选关系节点中不参与查询的节点，再进行查询操作
        this.selectedRelationIds = [];
        if(event.length>0){
            event.forEach(element => {
                let item = this.readonlySelfIds.filter(item => item == element.key);
                if(item.length == 0){
                    this.selectedRelationIds.push(element.key);
                }
            });
        }
        if(!$.trim(this.searchNodeName)){
            this.searchNodeName = this.lastSearchNodeName;
        }
        this.getNodeByName(true);
    }

    // enter键触发搜索关系树搜索
    handelEnterSearch(event) {
        if (event.keyCode == 13) {
            this.getRelationTreeByRelationName();
        }
    }

    // 根据实体名称查询图谱数据
    getNodeByName(isTreeNodeSelect?) {
        this.searchNodeName = $.trim(this.searchNodeName);
        if(!this.searchNodeName){
            this.message.danger('请输入节点名称！');
            return;
        }
        
        // 根据searchNodeName判断当前是进行单节点查询，两个节点间的路径查询
        let Params = {}

        // let arr = this.searchNodeName.split('、');
        let arr = [this.searchNodeName];

        // 查询节点
        if(arr.length == 1){
            if(!arr[0]){
                this.message.danger('请输入节点名称！');
                return;
            }
            Params = {
                startNode: arr[0],
                relationships: this.selectedRelationIds
            };
            this.searchType = 1;
        }
        // 查询关系
        if(arr.length == 2){
            if(!arr[0] || !arr[1]){
                this.message.danger('请输入节点名称！');
                return;
            }
            Params = {
                "current": 0,
                "depth": 6,
                "size": 50,
                "startNode": {
                  "nodeName": arr[0]
                },
                "endNode": {
                  "nodeName": arr[1]
                }
            };
            this.searchType = 2;
        }
        if(arr.length > 2){
            this.message.danger('请最多输入两个节点名称，节点名称中间请以、分隔！')
            return;
        }
        // 记录下当前搜索时的关键字（避免进行节点或关系相关操作后，需刷新图谱而缺少查询参数的问题）
        this.lastSearchNodeName = this.searchNodeName;
        this.initMapStatus = 1;
        this.isLoading = true;
        // 查询节点
        if(this.searchType == 1){
            // 查询节点信息
            this.kmsService.getNodeByParam(Params).subscribe(
                res => {
                    // 清除图谱
                    this.emptyMapDatas();
                    if (res.code == 200) {
                        let datas = res.data;
                        if (datas) {
                            let links = [];
                            if(datas.relationships && datas.relationships.length>0){
                                links = datas.relationships.map(d => Object.create(d));
                            }
                            let nodes = [];
                            if(datas.nodes && datas.nodes.length>0){
                                nodes = datas.nodes.map(d => Object.create(d));
                            }
                            this.draggedStatus = 0;
                            this.showMap(links, nodes);
                        } else {
                            this.message.info('暂未录入该节点信息！');
                        }
                    } else {
                        this.isLoading = false;
                        this.message.waring('暂未录入该节点信息！');
                    }
                }
            );
            // 查询当前节点所有的关系数据
            if(!isTreeNodeSelect){
                this.getRelatedRelations(arr[0]);
            }
        }
        // 查询关系路径
        else{
            this.kmsService.queryPathByParam(Params).subscribe(
                res => {
                    if (res.code == 200) {
                        let datas = res.data;
                        // 清除图谱
                        this.emptyMapDatas();
                        if (datas) {
                            let links = []; 
                            let nodes = [];
                            this.pathList = [];
                            for(let key in datas){
                                datas[key].forEach(item => {
                                    this.pathList.push(item);
                                    item.nodes.forEach(element => {
                                        if(nodes.filter( el => el.properties.nodeId == element.properties.nodeId).length == 0){
                                            nodes.push(element);
                                        }
                                    });
                                    item.relationships.forEach(element => {
                                        if(links.filter( el => el.properties.uuid == element.properties.uuid).length == 0){
                                            links.push(element);
                                        }
                                    });
                                })
                            }
                            this.pageDatas = this.pathList.slice(0,this.pageBase.pageNum);
                            const pages = Math.ceil(this.pathList.length/this.pageBase.pageNum);
                            this.pageBase.current = 1;
                            this.pageBase.pages = pages;
                            this.pageBase.total = this.pathList.length;

                            let links1 = links.map(d => Object.create(d));
                            let nodes1 = nodes.map(d => Object.create(d));
                            this.draggedStatus = 0;
                            this.showMap(links1, nodes1);
                        } else {
                            this.isLoading = false;
                            this.pathList = [];
                            this.pageDatas = [];
                            this.pageBase.current = 0;
                            this.pageBase.pages = 0;
                            this.pageBase.total = 0;
                            this.message.info('当前查询的两个节点之间暂未录入任何关联关系！');
                        }
                    } else {
                        this.isLoading = false;
                        this.message.waring(res.msg);
                    }
                }
            );
        }
    };

    // 清空图谱数据
    emptyMapDatas() {
        d3.select('.arrows').selectAll('marker').remove();
        d3.select('.arrows').selectAll('pattern').remove();
        d3.select('.relMap_g').selectAll('g').remove();
        d3.select('.relMap_g').selectAll('circle').remove();
        d3.select('.relMap_g').selectAll('text').remove();   
        // 隐藏节点菜单和关系菜单     
        $('.nodeMenus').fadeOut();
        $('.linkMenus').fadeOut();
        // 清除之前选中的节点及连线数据
        this.selectedNode = {};
        this.selectedLink = {
            relation: {
                uuid: ''
            },
            source: {},
            target: {}
        };
        // 重置选中路径索引
        this.selectedPathIndex = -1;
        this.selectedPage = -1;
        // 清除推荐实体信息
        this.instanceDatasList = [];
        // 关闭实体详情弹框
        $('.instanceDetail').animate({
            'right': '-400'
        },800)
        // 关闭关系编辑弹框
        $('.relationEdit').animate({
            'right': '-500'
        },800)
    }

    // 初始化图谱信息
    initMap() {
        // 画布的宽高
        this.d3Canvas.width = $('#knowledgeGraph').width();
        this.d3Canvas.height = $('#knowledgeGraph').height();
        // 图谱放大缩小
        d3.select("#knowledgeGraph").call(d3.zoom()
            .scaleExtent([1 / 2, 4])
            .on("zoom", this.zoomed));

        // 创建画布
        this.d3Canvas.svg = d3.select("#knowledgeGraph .svg g");

        // 箭头和图像初始化
        this.d3Canvas.defs = this.d3Canvas.svg.append("defs").attr("class", "arrows");
        // 其他元素初始化
        this.d3Canvas.relMap_g = this.d3Canvas.svg.append("g").attr("class", "relMap_g");
    }

    // 显示知识图谱方法
    showMap(links, nodes) {
        let _this = this;
        let arr = _this.lastSearchNodeName.split('、');
        let ghConfig = _this.d3Canvas.config;
        _this.d3Canvas.simulation = d3.forceSimulation(nodes)
            .force("link", d3.forceLink(links).id(d => d.id))
            .force("center", d3.forceCenter(_this.d3Canvas.width / 2, _this.d3Canvas.height / 2)) //  图谱居中
            .force("charge", d3.forceManyBody().strength(-1000))
            .force("link", d3.forceLink(links).distance(140)) // 线的长度
            .force("collision", d3.forceCollide(50))
            .force("x", d3.forceX())
            .force("y", d3.forceY());
        _this.d3Canvas.marker = _this.d3Canvas.defs.selectAll(".linkMarker")
            .data(links)
            .enter()
            .append("marker")
            .attr('id', function(d){
                return "marker-"+d.properties.uuid;
            })
            .attr("markerWidth", 10) //marker视窗的宽
            .attr("markerHeight", 10) //marker视窗的高
            .attr("refX", ghConfig.r + 4 * ghConfig.strokeWidth + 2) //refX和refY，指的是图形元素和marker连接的位置坐标
            .attr("refY", 4)
            .attr("orient", "auto") //orient="auto"设置箭头的方向为自动适应线条的方向
            .attr("markerUnits", "userSpaceOnUse") //marker是否进行缩放 ,默认值是strokeWidth,会缩放
            .append("path")
            .attr("d", "M 0 0 8 4 0 8Z") //箭头的路径 从 （0,0） 到 （8,4） 到（0,8）
            .attr("fill", ghConfig.linkColor);

        // 实体名称
        _this.d3Canvas.patterns = _this.d3Canvas.defs.selectAll("pattern.patternclass")
		    .data(nodes)
            .enter()
            .append("rect")
            .attr("class", function (d) {
                return 'rect' + d.id;
            })
            .attr("x", "0")
            .attr("y", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return 4 / 3 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 0;
                        } else {
                            return 4 / 3 * ghConfig.r;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return 4 / 3 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 0;
                        } else {
                            return 4 / 3 * ghConfig.r;
                        }
                    }
                }
            })
            .attr("width", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return 2 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 2 * ghConfig.label_r;
                        } else {
                            return 2 * ghConfig.r;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return 2 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 2 * ghConfig.label_r;
                        } else {
                            return 2 * ghConfig.r;
                        }
                    }
                }
            })
            .attr("height", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return 2 / 3 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 2 * ghConfig.label_r;
                        } else {
                            return 2 / 3 * ghConfig.r;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return 2 / 3 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 2 * ghConfig.label_r;
                        } else {
                            return 2 / 3 * ghConfig.r;
                        }
                    }
                }
            })
            .attr("fill", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return '#fff';
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return '#38cbd4';
                        } else {
                            return '#fff';
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return '#fff';
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return '#38cbd4';
                        } else {
                            return '#fff';
                        }
                    }
                }
            })
            .attr("opacity", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return 0.8;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 1;
                        } else {
                            return 0.8;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return 0.8;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return 1;
                        } else {
                            return 0.8;
                        }
                    }
                }

            })
        _this.d3Canvas.patterns.append("text")
            .attr("class", function (d) {
                return 'text' + d.id;
            })
            .attr("x", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return ghConfig.label_r;
                        } else {
                            return ghConfig.r;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return ghConfig.label_r;
                        } else {
                            return ghConfig.r;
                        }
                    }
                }
            })
            .attr("y", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return 5 / 3 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return ghConfig.label_r + 5;
                        } else {
                            return 5 / 3 * ghConfig.r;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return 5 / 3 * ghConfig.active_r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return ghConfig.label_r + 5;
                        } else {
                            return 5 / 3 * ghConfig.r;
                        }
                    }
                }
            })
            .attr('text-anchor', 'middle')
            .attr("fill", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return '#333';
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return '#fff';
                        } else {
                            return '#333';
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return '#333';
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return '#fff';
                        } else {
                            return '#333';
                        }
                    }
                }
            })
            .style("font-size", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return ghConfig.active_r / 3;
                    } else {
                        return ghConfig.r / 3;
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return ghConfig.active_r / 3;
                    } else {
                        return ghConfig.r / 3;
                    }
                }
            })
            .text(function (d) {
                return d.properties.name;
            });
        // 每条线是个容器，有线 和一个装文字的容器
        _this.d3Canvas.edges = _this.d3Canvas.relMap_g
            .selectAll("g.edge")
            .data(links)
            .enter()
            .append("g")
            .attr("class", function (d) {
                return "edges edge" + d.id;
            })
            .attr('fill', function (d) {
                return '#b5b5b5';
            })
            .attr("transform", function (d) {
                return _this.getTransform(d.source, d.target, _this.getDis(d.source, d.target))
            });
        // 添加线
        _this.d3Canvas.links = _this.d3Canvas.edges.append("path")
            .attr("class", "links")
            .attr("id", function(d){
                return 'links-'+d.properties.uuid
            })
            .attr('stroke-dasharray', function (d) {
                if (d.type == 'attribute' || d.type == 'Tag') {
                    return '2 4'
                }
            })
            .attr("d", d => {
                return "M" + 30 + "," + 0 + " L" + _this.getDis(d.source, d.target) + ",0";
            })
            .style("marker-end", function(d){
                return "url(#marker-"+d.properties.uuid+")";
            })
            .attr('stroke', (d) => {
                var str = d.color ? "#" + d.color : ghConfig.linkColor;
                return str;
            });

        // 添加关系文字的容器
        _this.d3Canvas.rect_g = _this.d3Canvas.edges.append("g")
            .attr("class", "rect_g")
            .style("cursor", "pointer")
            .on("click", function(d){
                console.log(d3.event);
                const p = [d3.event.x, d3.event.y];
                if (!d3.event.defaultPrevented) {
                    // 取消上次延时未执行的方法
                    clearTimeout(_this.d3Canvas.time);
                    // 执行延时
                    _this.d3Canvas.time = setTimeout(() => {
                       _this.drawRelationMenu(d,p);
                    }, 500);
                }
            });
        // 添加rect
        _this.d3Canvas.rects = _this.d3Canvas.rect_g.append("rect")
            .attr("y", -10)
            .attr("height", 20)
            .attr("id", function(d){
                return 'linkRect-'+d.properties.uuid
            })
            .attr("fill", function (d) {
                if (d.type == 'attribute' || d.type == 'Tag') {
                    return '#62b4e3'
                } else {
                    return ghConfig.linkBg
                }
            })
            .attr("stroke", function (d) {
                if (d.type == 'attribute' || d.type == 'Tag') {
                    return '#7ec5fb'
                } else {
                    return ghConfig.linkColor
                }
            })
            .attr('stroke-width', '1')
            .attr("rx", '10')
            .attr("ry", '15')

        // 关系名称  坐标（x,y）代表 文本的左下角的点
        _this.d3Canvas.texts = _this.d3Canvas.rect_g.append("text")
            .attr("text-anchor", "middle") // <text>文本中轴对齐方式居中  start | middle | end
            .style("font-size", function (d) {
                if (d.type == 'attribute' || d.type == 'Tag') {
                    return 10
                } else {
                    return 12
                }
            })
            .attr("id", function(d){
                return 'linkText-'+d.properties.uuid
            })
            .text(d => {
                return d.properties.relationshipName
            })
            .attr("fill", function (d) {
                if (d.type == 'attribute' || d.type == 'Tag') {
                    return '#fff'
                } else {
                    return '#0e1c41'
                }
            })
            .attr("y", function (d) {
                if (d.type == 'attribute' || d.type == 'Tag') {
                    return 4
                } else {
                    return 5
                }
            })
            .attr("x", function (d) {
                // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
                var bbox = d3.select(this).node().getBBox();
                var width = bbox.width;
                $(this).prev('rect').attr('width', width + 10);
                // 7.3.2 更新 text 的位置
                return _this.getDis(d.source, d.target) / 2
            })
            .attr("transform", function (d) {
                // 7.3.3 更新文本反正
                if (d.target.x < d.source.x) {
                    var x = _this.getDis(d.source, d.target) / 2;
                    return 'rotate(180 ' + x + ' ' + 0 + ')';
                } else {
                    return 'rotate(0)';
                }
            });
        this.d3Canvas.patterns = this.d3Canvas.defs
            .selectAll("pattern.patternclass")
            .data(nodes)
            .enter()
            .append("pattern")
            .attr("class", "patternclass")
            .attr("id", function(d, index) {
                return 'avatar' + d.id;
            })
            // 两个取值userSpaceOnUse  objectBoundingBox
            .attr('patternUnits', 'objectBoundingBox')
            // <pattern>，x、y值的改变决定图案的位置，宽度、高度默认为pattern图案占填充图形的百分比。
            .attr("x", "10")
            .attr("y", "10")
            .attr("width", "1")
            .attr("height", "1");
        // 关系图节点圆
        _this.d3Canvas.circles = _this.d3Canvas.relMap_g.selectAll("circle.circleclass")
            .data(nodes)
            .enter()
            .append("circle")
            .attr("class", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return 'circles active';
                    } else {
                        return 'circles';
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return 'circles active';
                    } else {
                        return 'circles';
                    }
                }
            })
            .style("cursor", "pointer")
            .attr("fill", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return "#FEBB00";
                    } else {
                        let items:any = {};
                        for(let x=0;x<d.labels.length;x++){
                            let res = _this.ontologyTreeDatas.filter(item => item.code === d.labels[x])
                            if(res.length>0){
                                items = res[0];
                                break;
                            }
                        }
                        if (items && items.color) {
                            if(d.properties.isDelete){
                                return 'rgba(189, 189, 189)';
                            }else{
                                return items.color.bg;
                            }
                        } else {
                            return '#83302E';
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return "#FEBB00";
                    } else {
                        let items:any = {};
                        for(let x=0;x<d.labels.length;x++){
                            let res = _this.ontologyTreeDatas.filter(item => item.code === d.labels[x])
                            if(res.length>0){
                                items = res[0];
                                break;
                            }
                        }
                        if (items && items.color) {
                            if(d.properties.isDelete){
                                return 'rgba(189, 189, 189)';
                            }else{
                                return items.color.bg;
                            }
                        } else {
                            return '#83302E';
                        }
                    }
                }
            })
            .attr("stroke", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return "rgba(254, 187, 0, 0.6)";
                    } else {
                        let items:any = {};
                        for(let x=0;x<d.labels.length;x++){
                            let res = _this.ontologyTreeDatas.filter(item => item.code === d.labels[x])
                            if(res.length>0){
                                items = res[0];
                                break;
                            }
                        }
                        if (items && items.color) {
                            if(d.properties.isDelete){
                                return 'rgba(189, 189, 189, 0.6)';
                            }else{
                                return items.color.br;
                            }
                        } else {
                            return "rgba(61, 188, 142, 0.6)";
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return "rgba(254, 187, 0, 0.6)";
                    } else {
                        let items:any = {};
                        for(let x=0;x<d.labels.length;x++){
                            let res = _this.ontologyTreeDatas.filter(item => item.code === d.labels[x])
                            if(res.length>0){
                                items = res[0];
                                break;
                            }
                        }
                        if (items && items.color) {
                            if(d.properties.isDelete){
                                return 'rgba(189, 189, 189, 0.6)';
                            }else{
                                return items.color.br;
                            }
                        } else {
                            return "rgba(61, 188, 142, 0.6)";
                        }
                    }
                }
            })
            .attr("stroke-width", function (d) {
                return '8';
            })
            .attr("r", function (d) {
                // 节点搜索
                if(_this.searchType == 1){
                    if (d.properties.nodeName == _this.lastSearchNodeName) {
                        return ghConfig.r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return ghConfig.label_r;
                        } else {
                            return ghConfig.r;
                        }
                    }
                }
                // 关系搜索
                else {
                    if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                        return ghConfig.r;
                    } else {
                        if (d.labels[0] == 'attribute_value' || d.labels[0] == 'TagNode') {
                            return ghConfig.label_r;
                        } else {
                            return ghConfig.r;
                        }
                    }
                }
            })
            .attr("cx", function (d) {
                return d.x;
            })
            .attr("cy", function (d) {
                return d.y;
            })
            // 鼠标单击
            .on('click', function (d, i) {
                // if (!d3.event.defaultPrevented) {
                //     if(!d.properties.isDelete){
                //         _this.selectedNode = d.properties;
                //         // 取消上次延时未执行的方法
                //         clearTimeout(_this.d3Canvas.time);
                //         // 执行延时
                //         _this.d3Canvas.time = setTimeout(() => {
                //            _this.drawCirclePartition(d);
                //         }, 500);
                //     }else{
                //         _this.message.danger('当前节点已进入回收站！');
                //     }
                // }
            })
            .call(_this.drag(_this.d3Canvas.simulation));
        _this.d3Canvas.circleText = _this.d3Canvas.relMap_g.selectAll("text.textclass")
            .data(nodes)
            .enter()
            .append("text")
            .attr('class', 'circletext')
            .attr('font-size', 12)
            .style('fill', function (d) {
                return "#1e1e1e";
                // // 节点搜索
                // if(_this.searchType == 1){
                //     if (d.properties.nodeName == _this.lastSearchNodeName) {
                //         return "#1e1e1e";
                //     } else {
                //         let items = _this.ontologyTreeDatas.filter(item => item.code === d.labels[0])[0];
                //         if (items && items.color) {
                //             return items.color.text;
                //         } else {
                //             return "#ffffff";
                //         }
                //     }
                // }
                // // 关系搜索
                // else {
                //     if (d.properties.nodeName == arr[0] || d.properties.nodeName == arr[1]) {
                //         return "#1e1e1e";
                //     } else {
                //         let items = _this.ontologyTreeDatas.filter(item => item.code === d.labels[0])[0];
                //         if (items && items.color) {
                //             return items.color.text;
                //         } else {
                //             return "#ffffff";
                //         }
                //     }
                // }
            })
		    .attr("dominant-baseline","middle")
		    .attr("text-anchor", "middle")//在圆圈中加上数据
		    .text(function(d){
                // if (d.properties.nodeName.length > 5) {
                //     return d.properties.nodeName.substring(0,5);
                // } else {
                //     return d.properties.nodeName;
                // }
                return d.properties.nodeName;
            })
            .attr("x", function (d) {
                return d.x;
            })
            .attr("y", function (d) {
                return d.y;
            })
            .style("cursor", "pointer")
            // 鼠标单击
            .on('click', function (d) {
                // if (!d3.event.defaultPrevented) {
                //     if(!d.properties.isDelete){
                //         _this.selectedNode = d.properties;
                //         // 取消上次延时未执行的方法
                //         clearTimeout(_this.d3Canvas.time);
                //         // 执行延时
                //         _this.d3Canvas.time = setTimeout(() => {
                //         _this.drawCirclePartition(d);
                //         }, 500);
                //     }else{
                //         _this.message.danger('当前节点已进入回收站！');
                //     }
                // }
            });

        // 图谱显示位置
        _this.d3Canvas.simulation.on("tick", () => {
            _this.updateMapLocation();
            // if (_this.draggedStatus === 1) {
            //     _this.updateMapLocation(links);
            //     return;
            // }
            // if (_this.initMapStatus == 1) {
            //     _this.isLoading = true;
            //     if (_this.d3Canvas.simulation.alpha() <= 0.05) {
            //         _this.isLoading = false;
            //         _this.updateMapLocation(links);
            //     }
            //     _this.initMapStatus = 2;
            // } else {
            //     if (_this.d3Canvas.simulation.alpha() <= 0.05) {
            //         _this.updateMapLocation(links);
            //     }
            // }
            
        });
        // return svg.node();
    }

    // 更新图谱位置方法
    updateMapLocation() {
        let _this = this;
        _this.isLoading = false;
        // 足够稳定时，才渲染一次
        _this.d3Canvas.rects
            .attr("x", function (d) {
                return _this.getDis(d.source, d.target) / 2 - $(this).attr('width') / 2
            }) // x 坐标为两点中心距离减去自身长度一半

        _this.d3Canvas.circles
            .attr("cx", function (d) {
                return d.x;
            })
            .attr("cy", function (d) {
                return d.y;
            })
        _this.d3Canvas.circleText
            .attr("x", function (d) {
                return d.x;
            })
            .attr("y", function (d) {
                return d.y;
            })

        _this.d3Canvas.texts
            .attr("x", function (d) {
                // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
                var bbox = d3.select(this).node().getBBox();
                var width = bbox.width;
                $(this).prev('rect').attr('width', width + 10);
                // 7.3.2 更新 text 的位置
                return _this.getDis(d.source, d.target) / 2
            })
            .attr("transform", function (d) {
                // 7.3.3 更新文本反正
                if (d.target.x < d.source.x) {
                    var x = _this.getDis(d.source, d.target) / 2;
                    return 'rotate(180 ' + x + ' ' + 0 + ')';
                } else {
                    return 'rotate(0)';
                }
            });

        _this.d3Canvas.links
            .attr("d", d => {
                return "M" + 30 + "," + 0 + " L" + _this.getDis(d.source, d.target) + ",0";
            })

        _this.d3Canvas.edges
            .attr("transform", function (d) {
                return _this.getTransform(d.source, d.target, _this.getDis(d.source, d.target))
            });
    }

    // 图谱缩放相关函数
    zoomed() {
        $('.nodeMenus').fadeOut();
        $('.linkMenus').fadeOut();
        d3.select(".nodeMenus").attr("transform", "translate(" + d3.event.transform.x + "," + d3.event.transform.y +
		") scale(" + d3.event.transform.k + "," + d3.event.transform.k + ")");
        d3.select(".svgBox").attr("transform", "translate(" + d3.event.transform.x + "," + d3.event.transform.y +
            ") scale(" + d3.event.transform.k + "," + d3.event.transform.k + ")");
    }

    // 求元素移动到目标位置所需要的 transform 属性值
    getTransform(source, target, _dis) {
        var r;
        if (target.x > source.x) {
            if (target.y > source.y) {
                r = Math.asin((target.y - source.y) / _dis)
            } else {
                r = Math.asin((source.y - target.y) / _dis);
                r = -r;
            }
        } else {
            if (target.y > source.y) {
                r = Math.asin((target.y - source.y) / _dis);
                r = Math.PI - r;
            } else {
                r = Math.asin((source.y - target.y) / _dis);
                r -= Math.PI;
            }
        }
        r = r * (180 / Math.PI);
        return "translate(" + source.x + "," + source.y + ")rotate(" + r + ")";
    }

    // 求两点间的距离
    getDis(s, t) {
        return Math.sqrt((s.x - t.x) * (s.x - t.x) + (s.y - t.y) * (s.y - t.y));
    }

    // 图谱拖拽相关函数
    drag(simulation) {
        let _this = this;
        function dragstarted(d) {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }

        function dragged(d) {
            $('.nodeMenus').fadeOut();
            $('.linkMenus').fadeOut();
            _this.draggedStatus = 1;
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragended(d) {
            if (!d3.event.active) simulation.alphaTarget(0);
            d.fixed = true; // 图谱线的拖动
            // d.fy = null;
        }
        return d3.drag()
            .on("start", dragstarted)
            .on("drag", dragged)
            .on("end", dragended);
    }

    // 图谱节点点击事件 ,节点添加圆形分区（添加三页扇形）
    drawCirclePartition(d) {
        $('.nodeMenus').fadeIn();
        let _this = this;
        let datas = d;
        let x = datas.x, y = datas.y;

        d3.select(".circle1")
            .attr('cx', x)
            .attr('cy', y)
            .attr('transform', 'rotate(0 ' + x + ' ' + y + ')')
            .style("cursor", "pointer")
            .on('click', function() {
                console.log('1');
            })

        d3.select(".circle2")
            .attr('cx', x)
            .attr('cy', y)
            .attr('transform', 'rotate(120 ' + x + ' ' + y + ')')
            .style("cursor", "pointer")
            .on('click', function() {
                console.log('2');
            })

        d3.select(".circle3")
            .attr('cx', x)
            .attr('cy', y)
            .attr('transform', 'rotate(240 ' + x + ' ' + y + ')')
            .style("cursor", "pointer")
            .on('click', function() {
                console.log('3');
            })

        d3.select(".icon-btn1")
            .attr('cx', x - 50)
            .attr('cy', y)
            .style("cursor", "pointer")
            .on('click', function() {
                $('.nodeMenus').fadeOut();
                _this.editNode();
            });

        d3.select(".icon-btn2")
            .attr('cx', x + 28)
            .attr('cy', y - 43)
            .style("cursor", "pointer")
            .on('click', function() {
                $('.nodeMenus').fadeOut();
                _this.instanceParams = {
                    instanceId: _this.selectedNode.nodeId,
                    instanceName: _this.selectedNode.nodeName
                }
                _this.toggleQueryInstance(true);
            });

        d3.select(".icon-btn3")
            .attr('cx', x + 30)
            .attr('cy', y + 52)
            .style("cursor", "pointer")
            .on('click', function() {
                $('.nodeMenus').fadeOut();
                if(_this.selectedNode.isDelete){
                    _this.message.danger('当前节点不允许删除！');
                }else{
                    _this.deleteNode();
                }
            });
    }

    // 查看节点详情方法
    toggleQueryInstance(state) {
        if(state){
            this.toggleEditRelation(false);
            // $('.instanceDetail').animate({
            //     'right': '20'
            // },800)
            this.create.createModal(InstanceInfoViewComponent, this.instanceParams);
        }else{
            // $('.instanceDetail').animate({
            //     'right': '-400'
            // },800)
        }
    }

    // 编辑节点
    editNode(){
        // 先判断审核状态 ，审核状态为已通过的节点不允许编辑
        this.kmsService.queryApprovalStatusById(this.selectedNode.nodeId).subscribe(
            data => {
                if(data.code == '200'){
                    if(data.data && data.data === 1){
                        this.message.info('当前节点信息已审核通过，不允许编辑!');
                    }else{
                        // 执行编辑操作
                        let selectData = {
                            addOrUpdate: 'Edit',
                            instanceId: this.selectedNode.nodeId,
                            conceptId: this.selectedNode.conceptId,
                            conceptName: this.selectedNode.conceptName,
                            serialNumber: this.selectedNode.serialNumber,
                        };
                        this.router.navigate(['/kms/InstanceAdd'],{ queryParams: { Title: '编辑实体信息', selectData: JSON.stringify(selectData) } });
                    }
                }else{
                    this.message.waring(data.msg);
                }
            }
        )
    }

    // 删除节点
    deleteNode(){
        // 先判断审核状态 ，审核状态为已通过的节点不允许删除
        this.kmsService.queryApprovalStatusById(this.selectedNode.nodeId).subscribe(
            data => {
                if(data.code == '200'){
                    if(data.data && data.data === 1){
                        this.message.info('当前节点信息已审核通过，不允许删除!');
                    }else{
                        // 执行删除操作
                        this.trim.openCLick('确认删除"'+this.selectedNode.nodeName+'"吗？', (data) => {
                            if (data) {
                                this.kmsService.deleteInstanceById([this.selectedNode.nodeId]).subscribe(
                                    result => {
                                        if (result.code == 200) {
                                            this.message.success('删除成功！');
                                            this.searchNodeName = this.lastSearchNodeName;
                                            this.getNodeByName(true);
                                        }
                                    }
                                )
                            }
                        })
                    }
                }else{
                    this.message.waring(data.msg);
                }
            }
        )
    }

    // 图谱关系点击事件：绘制关系目录
    drawRelationMenu(d,p){
        // 给之前选中的关系移除选中样式
        let lastSelectLink = this.selectedLink.relation;
        let _this = this;
        let ghConfig = _this.d3Canvas.config;
        if(lastSelectLink && lastSelectLink.uuid){
            d3.select("#links-"+lastSelectLink.uuid)
              .attr('stroke', (d) => {
                var str = d.color ? "#" + d.color : ghConfig.linkColor;
                return str;
            });
            d3.select("#linkRect-"+lastSelectLink.uuid)
                .attr("fill", function (d) {
                    if (d.type == 'attribute' || d.type == 'Tag') {
                        return '#62b4e3'
                    } else {
                        return ghConfig.linkBg
                    }
                })
                .attr("stroke", function (d) {
                    if (d.type == 'attribute' || d.type == 'Tag') {
                        return '#7ec5fb'
                    } else {
                        return ghConfig.linkColor
                    }
                })
            d3.select("#linkText-"+lastSelectLink.uuid)
                .attr("fill", function (d) {
                    if (d.type == 'attribute' || d.type == 'Tag') {
                        return '#fff'
                    } else {
                        return '#0e1c41'
                    }
                })
            d3.select("#marker-"+lastSelectLink.uuid)
                .select('path')
                .attr("fill", ghConfig.linkColor);
        }
        // 给当前选中的关系添加选中样式
        d3.select("#links-"+d.properties.uuid)
            .attr('stroke', (d) => {
                return 'rgba(254, 187, 0, 0.6)'
            });
        d3.select("#linkRect-"+d.properties.uuid)
          .attr("fill",function(d){
            return 'rgb(254, 187, 0)'
          })
          .attr("stroke", function (d) {
            return 'rgba(254, 187, 0, 0.6)'
          });
        d3.select("#linkText-"+d.properties.uuid)
            .attr("fill", function (d) {
                return '#ffffff'
            });
        d3.select("#marker-"+d.properties.uuid)
            .select('path')
            .attr("fill", (d) => {
                return 'rgba(254, 187, 0, 0.6)'
            });
        this.selectedLink = {
            relation: d.properties,
            source: d.source.properties,
            target: d.target.properties
        }
        $('.linkMenus').css({
            'left': p[0] * 0.6,
            'top': p[1] * 0.86
        }).fadeIn();
    }

    // 新增关系
    addRelation(){
        $('.linkMenus').fadeOut();
        this.toggleEditRelation(true);
        this.title = '新增关系';
        let params = {
            upOrAdd: 'Add',
            relationData: {
                isGraghAdd: true,
                sourceUUID: this.selectedLink.source.nodeId,
                sourceConceptId: this.selectedLink.source.conceptId,
                sourceConceptName: this.selectedLink.source.conceptName,
                sourceNodeName: this.selectedLink.source.nodeName
            }
        }
        this.relationParams = JSON.parse(JSON.stringify(params));
    }

    // 编辑关系
    editRelation(){
        $('.linkMenus').fadeOut();
        this.toggleEditRelation(true);
        this.title = '编辑关系';
        let params = {
            upOrAdd: 'Edit',
            relationData: {
                sourceUUID: this.selectedLink.source.nodeId,
                properties: this.selectedLink.relation
            }
        }
        this.relationParams = JSON.parse(JSON.stringify(params));
    }

    // 关系编辑组件切换展示方法
    toggleEditRelation(state) {
        if(state){
            this.toggleQueryInstance(false);
            $('.relationEdit').animate({
                'right': '20'
            },800);
        }else{
            $('.relationEdit').animate({
                'right': '-500'
            },800)
        }
    }
    
    // 关系编辑回调
    relationEditCallback(event){
        this.toggleEditRelation(false);
        this.searchNodeName = this.lastSearchNodeName;
        this.selectedRelationIds = [];
        this.getNodeByName();
    }

    // 删除关系
    deleteRelation(){
        $('.linkMenus').fadeOut();
        // 删除方法
        let relation = this.selectedLink.relation;
        let source = this.selectedLink.source;
        let target = this.selectedLink.target;
        let params = [
            {
                startNodeId: source.nodeId,
                uuid: relation.uuid
            }
        ]
        this.trim.openCLick('确认删除“'+(source.nodeName + '—' + relation.relationshipName + '—' + target.nodeName)+'”吗？', (data) => {
            if (data) {
                this.kmsService.deleteRelationshipById(params).subscribe(
                    result => {
                        if (result.code == 200) {
                            this.message.success('删除成功！');
                            this.searchNodeName = this.lastSearchNodeName;
                            this.selectedRelationIds = [];
                            this.getNodeByName();
                        }
                    }
                )
            }
        })
    }

    // 查看关系路径
    selectPath(i){
        // 给之前选中的关系移除选中样式
        let _this = this;
        let ghConfig = _this.d3Canvas.config;
        let lastIndex = this.selectedPathIndex;
        if(this.selectedPage>=1 && lastIndex >= 0){
            const start = (this.selectedPage - 1)*this.pageBase.pageNum;
            const end = this.selectedPage*this.pageBase.pageNum
            let lastPageData = this.pathList.slice(start,end)
            let lastLinks = lastPageData[lastIndex]['relationships'];
            lastLinks.forEach(item => {
                d3.select("#links-"+item.properties.uuid)
                  .attr('stroke', (d) => {
                    var str = d.color ? "#" + d.color : ghConfig.linkColor;
                    return str;
                });
                d3.select("#linkRect-"+item.properties.uuid)
                    .attr("fill", function (d) {
                        if (d.type == 'attribute' || d.type == 'Tag') {
                            return '#62b4e3'
                        } else {
                            return ghConfig.linkBg
                        }
                    })
                    .attr("stroke", function (d) {
                        if (d.type == 'attribute' || d.type == 'Tag') {
                            return '#7ec5fb'
                        } else {
                            return ghConfig.linkColor
                        }
                    })
                d3.select("#linkText-"+item.properties.uuid)
                    .attr("fill", function (d) {
                        if (d.type == 'attribute' || d.type == 'Tag') {
                            return '#fff'
                        } else {
                            return '#0e1c41'
                        }
                    })
                d3.select("#marker-"+item.properties.uuid)
                    .select('path')
                    .attr("fill", ghConfig.linkColor);
            });
        }
        // 给当前选中的关系添加选中样式
        this.selectedPathIndex = i;
        this.selectedPage = this.pageBase.current;
        let links = this.pageDatas[i]['relationships'];
        links.forEach(item => {
            d3.select("#links-"+item.properties.uuid)
                .attr('stroke', (d) => {
                    return 'rgba(254, 187, 0, 0.6)'
                });
            d3.select("#linkRect-"+item.properties.uuid)
              .attr("fill",function(d){
                return 'rgb(254, 187, 0)'
              })
              .attr("stroke", function (d) {
                return 'rgba(254, 187, 0, 0.6)'
              });
            d3.select("#linkText-"+item.properties.uuid)
                .attr("fill", function (d) {
                    return '#ffffff'
                });
            d3.select("#marker-"+item.properties.uuid)
                .select('path')
                .attr("fill", (d) => {
                    return 'rgba(254, 187, 0, 0.6)'
                });
        })
    }

    // 查询实体列表信息数据
    getInstanceList() {
        let keyword = $.trim(this.searchNodeName);
        if(!keyword){
            this.instanceDatasList = [];
            return;
        }
        if(keyword.indexOf('、')>=0){
            this.instanceDatasList = [];
            return;
        }
        let Params = {
            current: 1,
            size: 30,
            instanceName: $.trim(this.searchNodeName)
        };
        this.kmsService.getInstanceQueryList(Params).subscribe(
            result => {
                if (result.code == 200) {
                    this.instanceDatasList = result.data.records;
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 实体输入框获取焦点时方法
    handleFocusFun() {
        this.getInstanceList();
    }

    // 实体输入框失去焦点时方法
    handleBlurFun() {
        setTimeout(() => {
            this.instanceDatasList = [];
        }, 200);
    }

    // 实体下拉搜索列表点击事件
    handleSearchInstanceClick(data) {
        this.instanceDatasList = [];
        // 设置查询参数，查询节点数据
        this.searchNodeName = data.instanceName;
        this.selectedRelationIds = [];
        this.getNodeByName();
    }

    // 根据实体名称查询该实体所有关联的关系信息
    getRelatedRelations(nodeName){
        // 数据重置
        this.isRelationTreeLoading = true;
        this.searchRelationName = '';
        this.instanceRelationTree = [];
        this.relationTreeData = [];
        this.readonlySelfIds = [];
        this.selectedRelationIds = [];
        // 查询该节点关联的所有关系数据，并再关系树数据中筛选出所有的父级节点，渲染新的关系树
        this.kmsService.queryRelationsByNodeName(nodeName).subscribe(
            data => {
                this.isRelationTreeLoading = false;
                if(data.code == '200'){
                    // 获取该节点关联的所有关系数据
                    this.instanceRelationTree = Array.isArray(data.data) && data.data.length > 0 ? data.data : [];
                    if(this.instanceRelationTree.length == 0){
                        this.message.info('当前节点暂未录入任何关联关系！');
                        return;
                    }
                    // 获取不参与图谱查询的关系节点
                    this.readonlySelfIds = [];
                    let leafNodes = [];
                    this.instanceRelationTree.forEach(element => {
                        // 判断当前节点是否包含子节点，是，则不参与查询
                        let item = this.instanceRelationTree.filter(item => item.pid == element.id);
                        if(item.length>0){
                            this.readonlySelfIds.push(element.id);
                        }
                        // 关系数量>0,则为叶子节点
                        if(element.shipTotal>0){
                            leafNodes.push(element)
                        }
                    });
                    // 遍历叶子节点，给它所有的父节点累加上当前节点的关系数
                    leafNodes.forEach(item => {
                        this.countShips(item);
                    })
                    this.instanceRelationTree.forEach(element => {
                        // 在关系名称后面拼接数量
                        element.text = element.text + "  (" + element.shipTotal + ")";
                    });
                    // 渲染新的关系树
                    this.relationTreeData = JSON.parse(JSON.stringify(this.instanceRelationTree));
                }else{
                    this.message.waring(data.msg);
                }
            }
        )
    }

    // 给所有包含叶子节点的父节点加上叶子节点的关系数量
    countShips(child){
        let firstNode = [];
        let secondNode = [];
        let thirdNode = [];
        // 获取一级父节点，并修改关系数量
        firstNode = this.instanceRelationTree.filter(item => item.id == child.pid);
        if(firstNode.length>0){
            firstNode[0]['shipTotal'] += child.shipTotal;
            // 获取二级父节点，并修改关系数量
            secondNode = this.instanceRelationTree.filter(item => item.id == firstNode[0].pid);
            if(secondNode.length>0){
                secondNode[0]['shipTotal'] += child.shipTotal;
                // 获取三级父节点，并修改关系数量
                thirdNode = this.instanceRelationTree.filter(item => item.id == secondNode[0].pid);
                if(thirdNode.length>0){
                    thirdNode[0]['shipTotal'] += child.shipTotal;
                }
            }
        }
    }

    // 根据关系名筛选关系数据
    getRelationTreeByRelationName(){
        if(this.instanceRelationTree.length == 0){
            this.relationTreeData = [];
            return;
        }
        let data = JSON.parse(JSON.stringify(this.instanceRelationTree));
        let relationName = $.trim(this.searchRelationName);
        if(relationName){
            // 先判断是否存在当前关系
            var filterArr= data.filter(item => item.text.indexOf(relationName)>=0);
            if(filterArr.length == 0){
                this.relationTreeData = [];
                return;
            }
            let res = [];
            filterArr.forEach(item => {
                res = this.getParents(item,res);
            })
            this.relationTreeData = res;
        }else{
            this.relationTreeData = data;
        }
    }

    // 根据当前项获取所有父级
    getParents(item,parents){
        let data = JSON.parse(JSON.stringify(this.instanceRelationTree));
        if(parents.filter(item1 => item1.id == item.id).length == 0){
            parents.push(item);
        }
        let parentNode = data.filter(el => el.id == item.pid);
        if(parentNode.length == 0){
            return parents
        }else{
            return this.getParents(parentNode[0],parents);
        }
    }

    // 设置默认勾选的关系节点
    setInitSelectedRelation(){
        // 默认选中第一个概念组下的所有关系节点,用于设置关系树默认选中
        let arr = this.instanceRelationTree.filter(item => item.level==0);
        if(arr.length>0){
            let arr1 = this.instanceRelationTree.filter(item => item.pid==arr[0].id);
            if(arr1.length>0){
                this.initSelectedNodes.push(arr1[0].id);
                let res = this.getChilds(arr1[0].id);
                let ids = res.map(item => item.id);
                this.initSelectedNodes = this.initSelectedNodes.concat(ids);
            }
        }
        // 获取剔除已选关系节点中不参与查询的节点，用于图谱查询操作
        this.selectedRelationIds = [];
        if(this.initSelectedNodes.length>0){
            this.initSelectedNodes.forEach(element => {
                let item = this.readonlySelfIds.filter(item => item == element);
                if(item.length == 0){
                    this.selectedRelationIds.push(element);
                }
            });
        }
    }

    // 获取当前概念组节点下的所有子级关系节点(默认只查找三级)
    getChilds(pid){
        let res = [];
        let firstChilds = this.instanceRelationTree.filter(item => item.pid == pid);
        let secondChilds = [];
        let thirdChilds = [];
        // 获取一级关系节点
        if(firstChilds.length>0){
            res = res.concat(firstChilds);
            // 获取二级关系节点
            firstChilds.forEach(element => {
                secondChilds = this.instanceRelationTree.filter(item => item.pid == element.id);
                if(secondChilds.length > 0){
                    res = res.concat(secondChilds);
                    // 获取三级关系节点
                    secondChilds.forEach(element => {
                        thirdChilds = this.instanceRelationTree.filter(item => item.pid == element.id);
                        if(thirdChilds.length > 0){
                            res = res.concat(thirdChilds);
                        }
                    });
                }
            });
        }
        return res;
    }

    // 关系路径列表切换上一页，下一页
    togglePage(state){
        if(state == 'prev'){
            this.pageBase.current--;
        }else{
            this.pageBase.current++;
        }
        const start = (this.pageBase.current - 1) * this.pageBase.pageNum;
        const end = this.pageBase.current * this.pageBase.pageNum;
        this.pageDatas = this.pathList.slice(start,end);
    }
}
